import UmbracoBase from './UmbracoBase';

export default class CallToAction extends UmbracoBase {
	constructor(args) {
		// Inheriting form UmbracoBase
		super(args);

		this.componentName = 'call-to-action';
		this.link = args.link || [];
		this.tagTitle = args.tagTitle;
		this.text = args.text;
		this.title = args.title;
		this.image = args.image;
		this.altText = args.altText;
		this.imageCation = args.imageCaption;
	}
}
